import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Navigate, Route, Routes } from "react-router-dom";
import { FoodHeader } from "./components/FoodHeader";
import { AnalysisView } from "./views/AnalysisView";
import { CategoriesView } from "./views/CategoriesView";
import { DashboardView } from "./views/DashboardView";
import { HelpView } from "./views/HelpView";
import { IngredientDetailView } from "./views/IngredientDetailView";
import { IngredientsView } from "./views/IngredientsView";
import { InvoiceDetailView } from "./views/InvoiceDetailView";
import { InvoicesView } from "./views/InvoicesView";
import { MenuDetailView } from "./views/MenuDetailView";
import { MenuView } from "./views/MenuView";
import { UploadInvoiceView } from "./views/UploadInvoiceView";

const FOOD_QUERY_CLIENT = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function FoodModuleInner() {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <FoodHeader />
      <div className="min-h-0 flex-1 overflow-y-auto">
        <Routes>
          <Route index element={<DashboardView />} />
          <Route path="categories" element={<CategoriesView />} />
          <Route path="ingredients" element={<IngredientsView />} />
          <Route path="ingredients/:id" element={<IngredientDetailView />} />
          <Route path="menu" element={<MenuView />} />
          <Route path="menu/:id" element={<MenuDetailView />} />
          <Route path="analysis" element={<AnalysisView />} />
          <Route path="invoices" element={<InvoicesView />} />
          <Route path="invoices/:id" element={<InvoiceDetailView />} />
          <Route path="upload" element={<UploadInvoiceView />} />
          <Route path="help" element={<HelpView />} />
          <Route path="*" element={<Navigate to="/food" replace />} />
        </Routes>
      </div>
    </div>
  );
}

export function FoodModule() {
  return (
    <QueryClientProvider client={FOOD_QUERY_CLIENT}>
      <FoodModuleInner />
    </QueryClientProvider>
  );
}
